import { Button } from "@/components/ui/button";
import { eur } from "@/components/excelVoce/format";

export const SalPagamenti = ({ x, onAdd, onAnnulla }) => (
  <div className="rounded-md border p-4 space-y-2" data-testid="sal-pagamenti">
    <div className="flex items-center gap-2">
      <div className="mr-auto text-xs font-semibold text-slate-700">Pagamenti effettivamente eseguiti</div>
      {onAdd && Number(x.residuo_da_pagare) > 0 && <Button size="sm" variant="outline" onClick={onAdd} data-testid="pagamento-aggiungi">Registra pagamento</Button>}
    </div>
    {!x.pagamenti.length && <p className="text-xs text-slate-500">Nessun pagamento registrato. Residuo da pagare: {eur(x.residuo_da_pagare)}</p>}
    <ul className="text-xs space-y-1">{x.pagamenti.map((p) => (
      <li key={p.id} className={`flex flex-wrap gap-2 items-center ${p.annullato ? "line-through text-slate-400" : ""}`} data-testid={`pagamento-${p.id}`}>
        <span>{p.data}</span><span className="font-mono">{eur(p.importo)}</span><span>{p.riferimento}</span><span className="text-slate-500">{p.autore}</span>
        {p.annullato && <span className="no-underline text-rose-600">annullato: {p.annullato_motivo}</span>}
        {!p.annullato && onAnnulla && <button type="button" className="text-rose-600 underline" onClick={() => onAnnulla(p)} data-testid={`pagamento-annulla-${p.id}`}>annulla</button>}
      </li>))}
    </ul>
  </div>
);
